
 

 

 

    import DashboardSearchCriteria from 'Modules/Aqs/Scripts/AppServiceContract/DashboardSearchCriteria';

    import PagingCriteria from 'Lib/Fs.Core.Data/PagingCriteria';

 
class DashboardSearchParameter 
{
    
        Criteria: DashboardSearchCriteria;
    
        SortingCriteria: any;
    
        PagingCriteria: PagingCriteria;
    
}
 
export default DashboardSearchParameter;
 




